/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API - V2 Redesigned
 * Redesigned API endpoints (v2) for better performance with smaller, functional DTOs. Each endpoint provides only the data needed for specific UI components/tabs.  V2 endpoints are designed to replace heavy monolithic v1 endpoints: - Reduced response sizes by 80-95% - Component-specific data loading - Pagination and filtering support - Optimized for mobile and slow connections 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamRegistrationTemplateFieldRule } from './TeamRegistrationTemplateFieldRule';
import {
    TeamRegistrationTemplateFieldRuleFromJSON,
    TeamRegistrationTemplateFieldRuleFromJSONTyped,
    TeamRegistrationTemplateFieldRuleToJSON,
    TeamRegistrationTemplateFieldRuleToJSONTyped,
} from './TeamRegistrationTemplateFieldRule';

/**
 * 
 * @export
 * @interface TeamRegistrationTemplate
 */
export interface TeamRegistrationTemplate {
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationTemplate
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationTemplate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamRegistrationTemplate
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeamRegistrationTemplate
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TeamRegistrationTemplate
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TeamRegistrationTemplate
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Array<TeamRegistrationTemplateFieldRule>}
     * @memberof TeamRegistrationTemplate
     */
    fieldRules?: Array<TeamRegistrationTemplateFieldRule>;
}

/**
 * Check if a given object implements the TeamRegistrationTemplate interface.
 */
export function instanceOfTeamRegistrationTemplate(value: object): value is TeamRegistrationTemplate {
    return true;
}

export function TeamRegistrationTemplateFromJSON(json: any): TeamRegistrationTemplate {
    return TeamRegistrationTemplateFromJSONTyped(json, false);
}

export function TeamRegistrationTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamRegistrationTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'active': json['active'] == null ? undefined : json['active'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'fieldRules': json['field_rules'] == null ? undefined : ((json['field_rules'] as Array<any>).map(TeamRegistrationTemplateFieldRuleFromJSON)),
    };
}

export function TeamRegistrationTemplateToJSON(json: any): TeamRegistrationTemplate {
    return TeamRegistrationTemplateToJSONTyped(json, false);
}

export function TeamRegistrationTemplateToJSONTyped(value?: TeamRegistrationTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'active': value['active'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'field_rules': value['fieldRules'] == null ? undefined : ((value['fieldRules'] as Array<any>).map(TeamRegistrationTemplateFieldRuleToJSON)),
    };
}

